import "./styles/global.css";
import "./styles/responsive.css";

import AppShell from "./ui/app/layout/AppShell";
import { AppProvider, useApp } from "./state/Context";
import { AuthProvider } from "./state/AuthContext";   
import AuthEmailLinkHandler from "./state/AuthEmailLinkHandler";

import SelectScreen from "./ui/features/pages/SelectScreen";
import Calculator from "./ui/features/pages/Calculator";
import Privacy from "./ui/features/pages/Privacy";
import HowItsDone from "./ui/features/pages/HowItsDone";
import Timeline from "./ui/features/pages/Timeline";
import TermsAndConditions from "./ui/features/pages/TermsAndConditions";

function AppInner() {
  const { selection, setSelection } = useApp();

  const resetSelection = () => {
    setSelection({ step: "select", university: null, degreeLevel: null });
  };

  const hasRequiredSelection = Boolean(selection?.university && selection?.degreeLevel);
  const showCalculator = Boolean(selection?.step === "calc" && hasRequiredSelection);

  return (
    <AppShell onChangeSelection={resetSelection}>
      {selection?.step === "privacy" ? (
        <Privacy />
      ) : selection?.step === "how" ? (
        <HowItsDone />
      ) : selection?.step === "timeline" ? (
        <Timeline />
      ) : selection?.step === "terms" ? (
        <TermsAndConditions />
      ) : showCalculator ? (
        <Calculator />
      ) : (
        <SelectScreen />
      )}
    </AppShell>
  );
}


export default function App() {
  return (
    <AuthProvider>          
      <AppProvider>         
        <AuthEmailLinkHandler />
        <AppInner />
      </AppProvider>
    </AuthProvider>
  );
}

